import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Box } from '@rebass/grid';
import { weekdayMonthDayYear } from '@amtrav/dates';
import { Text } from '@amtrav/view-components';

const Label = styled(Box)`
  font-size: 14px;
  font-weight: 800;
`;

const TimeContainer = styled(Box)`
  text-transform: uppercase;
  font-size: 18px;
  display: flex;
  align-items: baseline;
`;

const TimePeriod = styled.div`
  font-size: 12px;
  padding-left: 2px;
`;

const DateContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
`;

const formatTime = (timeString) => {
  if (timeString === '0') {
    return { time: `12:00`, period: `AM` };
  }
  if (timeString === '30') {
    return { time: `12:30`, period: `AM` };
  }
  let hours = 0;
  let minutes = 0;

  if (timeString.length === 4) {
    hours = timeString.slice(0, 2);
    minutes = timeString.slice(2, 4);
  } else if (timeString.length === 3) {
    hours = timeString.slice(0, 1);
    minutes = timeString.slice(1, 3);
  }

  let period = 'AM';

  if (hours >= 12) {
    period = 'PM';
  }

  if (hours > 12) {
    hours -= 12;
  }

  if (hours === 0) {
    hours = 12;
  }

  const formattedTime = { time: `${hours}:${minutes}`, period: `${period}` };
  return formattedTime;
};

export const TimeDateDisplay = ({ time, date, label }) => {
  const dateString = date.toString();
  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);
  const dateObject = new Date(year, month - 1, day);

  const formattedTime = formatTime(time.toString());

  return (
    <div>
      <Label pb={2}>{label}</Label>
      <Text primary>
        <TimeContainer pb={1}>
          {formattedTime.time}
          <TimePeriod>{formattedTime.period}</TimePeriod>
        </TimeContainer>
        <DateContainer>{weekdayMonthDayYear(dateObject)}</DateContainer>
      </Text>
    </div>
  );
};

TimeDateDisplay.propTypes = {
  time: PropTypes.number,
  date: PropTypes.string,
  label: PropTypes.string,
};
